import { createGlobalStyle } from 'styled-components';
import 'antd/dist/antd.css';
import { CssVariables } from './variables';

const GlobalStyles = createGlobalStyle`
  ${CssVariables}
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logo {
    font-size: 32px;
    font-weight: 700;
    color: var(--white);
  }

  .ant-modal-mask {
    background-color: rgba(0, 0, 0, 0.4) !important;
    backdrop-filter: blur(2px);
  }

  .ant-modal-wrap {
    &.ml-0 {
      margin-left: 0px;
    }

    &.last-step-modal {
      .ant-modal {
        width: 700px !important;

        @media (max-width: 768px) {
          width: 95% !important;
        }
      }
    }

    &.waysToWrapModal {
      .ant-modal-content {
        .ant-modal-body {
          padding: 0;
        }
      }
    }

    &.noHeaderModal {
      .ant-modal-content {
        .ant-modal-body {
          padding: 0;
        }
      }
    }

    &.preivew-report-modal {
      .ant-modal {
        width: 95% !important;

        .modal-content {
          padding: 0;
        }

        .ant-modal-body {
          padding: 0px;

          @media screen and (max-width: 767px) {
            .ant-col-6 {
              order: 1;
            }

            .ant-col-18 {
              order: 2;
            }

            .ant-col {
              flex: 0 0 100%;
              max-width: 100%;
            }
          }

          .report-right-outer {
            .report-right-title {
              display: flex;
              width: 100%;
              justify-content: space-between;
              padding: 20px 25px 40px;
              align-items: center;
              border-bottom: 1px solid var(--silverberry);

              @media screen and (max-width: 1024px) {
                padding: 15px 20px 25px;
              }

              h4 {
                font-size: 20px;
                font-weight: bold;

                @media screen and (max-width: 1024px) {
                  font-size: 18px;
                }

                @media screen and (max-width: 992px) {
                  font-size: 14px;
                }
              }

              .modal-header {
                padding: 0px;
              }
            }

            .pagination-action {
              display: flex;
              align-items: center;
              justify-content: center;
              margin: 30px 0;

              .page-number-box {
                background-color: var(--wash-me);
                border: 1px solid var(--silverberry);
                border-radius: 4px;
                padding: 15px 30px;
                font-size: 15px;
                margin: 0 10px;
                display: flex;
                align-items: center;
                justify-content: center;

                @media screen and (min-width: 1799px) {
                  font-size: 20px;
                }

                @media screen and (max-width: 1024px) {
                  font-size: 12px;
                  padding: 10px 20px;
                  margin: 0 5px;
                }

                @media screen and (max-width: 992px) {
                  font-size: 12px;
                  padding: 10px 10px;
                  margin: 0 5px;
                }

                p {
                  margin: 0 3px;
                  color: var(--wild-iris);

                  &.active {
                    font-weight: 600;
                  }
                }
              }

              span {
                color: var(--wild-iris);
                font-size: 22px;
                margin: 0 3px;
                cursor: pointer;
                @media screen and (max-width: 1024px) {
                  font-size: 18px;
                }

                &.disabled {
                  color: var(--uniform-grey);
                  cursor: no-drop;
                }
              }
            }

            .report-download-btn {
              width: 245px;
              height: 50px;
              margin: 30px auto;
              padding: 15px;
              border-radius: 100px;
              background-image: linear-gradient(to right, var(--venetian-nights) -10%, var(--blue-chaos) 112%);
              color: var(--white);
              display: block;
              @media screen and (min-width: 1799px) {
                font-size: 20px;
              }
              @media screen and (max-width: 1024px) {
                width: 85%;
              }
            }
          }
        }
      }
    }

    &.requestInvoiceModal {
      margin: 20px;

      .ant-modal {
        width: 100% !important;
        max-width: 950px;
        margin: auto;

        .ant-modal-content {
          max-width: 950px;
          overflow: hidden;
        }
      }
    }
  }

  .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-thead > tr:hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
    background: var(--zhen-pearl) !important;
  }

  .ant-row.ant-form-item {
    margin-bottom: 5px;
  }

  .has-success.has-feedback {
    .ant-select {
      .ant-select-selection {
        .ant-select-selection__rendered {
          .ant-select-selection__placeholder {
            display: none !important;
          }
        }
      }
    }
  }

  /*-----------------------------------------------*/
  // style for project category menu [ScrumBoard]
  /*-----------------------------------------------*/
  .project-category {
    .ant-select-dropdown-menu {
      .ant-select-dropdown-menu-item {
        padding: 8px 12px;
        color: var(--black);
        font-family: 'Roboto';
        font-weight: 400;
      }
    }
  }

  /*-----------------------------------------------*/
  // style for project menu [ScrumBoard]
  /*-----------------------------------------------*/
  .ant-dropdown {
    &.project-menu {
      width: 280px;
      top: 133px !important;

      .ant-dropdown-menu {
        padding: 0;
        overflow: hidden;

        .ant-dropdown-menu-item {
          min-height: 54px;
          line-height: auto;
          display: flex;
          align-items: center;
          padding: 10px 20px;

          &:first-child {
            padding: 0;
            border-bottom: 1px solid var(--ma-white);

            &:hover,
            &:focus {
              background-color: var(--white);
            }
          }

          &:hover,
          &:focus {
            background-color: var(--cotton-ball);
          }

          &:last-child {
            background-color: var(--icy-lilac);
          }
        }
      }
    }
  }

  /*-----------------------------------------------*/
  // style for popover [ScrumBoard]
  /*-----------------------------------------------*/
  .ant-popover {
    .ant-checkbox-group {
      display: flex;
      flex-direction: column;

      .ant-checkbox-group-item {
        margin: 5px 0;

        span {
          font-size: 14px;
          color: var(--tranquil-pond);
          text-transform: capitalize;
        }
      }
    }
  }

  /*-----------------------------------------------*/
  // style for modal [ScrumBoard]
  /*-----------------------------------------------*/
  .ant-modal-wrap {
    .ant-modal {
      .ant-modal-content {
        border-radius: 10px;

        .ant-modal-body {
          .render-form-wrapper {
            padding: 10px;

            h2 {
              margin: 0;
            }

            form {
              padding: 15px 0 3px;

              .field-container {
                margin-bottom: 26px;
              }
            }
          }
        }
      }
    }
  }


  /*-----------------------------------------------*/
  // style form previous GlobalStyles
  /*-----------------------------------------------*/

  .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-thead > tr:hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
    background: var(--zhen-pearl) !important;
  }

  body {
    font-family: 'Open Sans', Roboto, sans-serif;
    min-width: 290px;
    overflow: auto;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  a,
  p,
  li,
  input,
  textarea,
  span,
  div,
  img,
  svg {
    &::selection {
      background: var(--bleuchatel-blue);
      color: var(--white);
    }
  }

  .ant-row:not(.ant-form-item) {
    &:before,
    &:after {
      display: none;
    }
  }

  .ant-row > div {
    padding: 0;
  }

  .isoLeftRightComponent {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .isoCenterComponent {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
    content: unset !important;
  }

  .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::after {
    content: '*';
    display: inline-block;
    margin-right: 4px;
    font-family: SimSun, sans-serif;
    font-size: 14px;
    line-height: 1;
    color: var(--blood-burst);
  }

  .formGroup {
    margin-bottom: 20px;
  }

  .fieldLabel {
    color: var(--dusty-chimney);
    font-size: 13px;
    display: block;
    margin-bottom: 10px;

    i {
      font-size: 12px;
    }
  }

  .text-center {
    text-align: center;
  }

  .helper-text {
    color: var(--flushed);
  }

  .mb-20 {
    margin-bottom: 20px;
  }

  .mt-10 {
    margin-top: 10px;
  }

  .table-global {
    width: 100%;
    height: 100%;

    thead {
      tr {
        th {
          background-color: var(--white);
          padding: 18px 10px;
          border-bottom: 1px solid var(--diamond-cut);
        }
      }
    }

    tbody {
      tr {
        td {
          padding: 10px;
        }
      }
    }
  }

  .topbar-overlay-menu {
    .ant-drawer-content-wrapper {
      @media only screen and (max-width: 520px) {
        width: 65vw !important;
      }
    }

    .ant-drawer-header {
      .ant-drawer-header-title {
        display: block;
      }

      .ant-drawer-close {
        color: var(--white);
        display: block;
        padding: 0;
        margin: 0 0 0 auto;
      }

      border: none;
      background: transparent;
    }

    .ant-drawer-content {
      .ant-drawer-wrapper-body {
        background-image: linear-gradient(to bottom, var(--blue-rose), var(--royalty) 62%, var(--purple-emperor));
      }

      .ant-drawer-body {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      .nav-text {
        color: var(--white);
        font-size: 1.125rem;
        padding-left: 0.5rem;
      }

      .ant-menu {
        border: none;
        background: transparent;

      }

      .ant-menu-item {
        &.ant-menu-item-selected,
        &.ant-menu-item-active {
          background-color: transparent;
          background-image: linear-gradient(to right, var(--venetian-nights), var(--blue-chaos));
          border-radius: 10px;
        }

        padding-left: 1rem;
      }
    }
  }

  .registerWalletModal {
    width: 75% !important;

    @media (min-width: 1140px) {
      width: 50% !important;
    }
  }

  @keyframes loadingCircle {
    to {
      transform: rotate(360deg);
    }
  }

  .icon-loading-outlined {
    animation: loadingCircle 1s infinite linear;
  }

  .icon-vertical-chevron-outlined,
  .icon-chevron-outlined,
  .icon-cart-outlined {
    transform-origin: center center;
    transition: transform 0.3s ease-in;

    &--right {
      transform: rotate(90deg);
    }

    &--down {
      transform: rotate(180deg);
    }

    &--left {
      transform: rotate(270deg);
    }
  }

  .icon-vertical-chevron-outlined,
  .icon-chevron-outlined {
    &.disabled {
      opacity: 0.7;
      cursor: not-allowed;
      pointer-events: none;
    }
  }

  /*-----------------------------------------------*/
  // style for popover [BuddiBot]
  /*-----------------------------------------------*/

  .threadContextMenu.ant-tooltip-placement-bottomLeft,
  .threadContextMenu.ant-tooltip-placement-topLeft {
    padding-top: 0 !important;
    //margin-top: -12px;

    .ant-tooltip-inner {
      padding: 12px 14px;
      border-radius: 10px;
      box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.06);
      border: solid 1px var(--alpine-goat);
      background-color: var(--white);
      width: 240px !important;
      margin-top: -6px;
    }
  }
`;

export default GlobalStyles;
